import { TabPanels } from "@headlessui/react";
import { NavigationTabPanel } from "./NavigationTabPanel";
import { useNavigationTabContext } from "./useNavigationTabContext";

export const NavigationTabPanels = () => {
  const { tabs, factory } = useNavigationTabContext();

  return (
    <TabPanels>
      {({ selectedIndex }) => (
        <>
          {tabs.map((tab, tabIndex) => (
            <NavigationTabPanel key={tab}>
              {selectedIndex === tabIndex ? factory(tab) : null}
            </NavigationTabPanel>
          ))}
        </>
      )}
    </TabPanels>
  );
};
